var _path, _mask, _g, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashboardPersonIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 137,
    viewBox: "0 0 194 137",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.5 137C163.332 137 194 106.332 194 68.5C194 30.6685 163.332 0 125.5 0C87.6685 0 57 30.6685 57 68.5C57 106.332 87.6685 137 125.5 137Z",
    fill: "#05719A"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 57,
    y: 0,
    width: 137,
    height: 137
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M125.5 137C163.332 137 194 106.332 194 68.5C194 30.6685 163.332 0 125.5 0C87.6685 0 57 30.6685 57 68.5C57 106.332 87.6685 137 125.5 137Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M120.089 81.8581C119.927 81.6711 103.657 63.0986 82.002 47.0897L120.089 81.8581Z",
    fill: "#1F2041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M89.9364 58.7362L79.8775 61.2794L76.2803 90.4038L88.0562 90.8849L89.9364 58.7362Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.0409 31.1296C96.1603 31.8028 88.1737 36.5186 88.1737 36.5186L82.5059 29.2613L84.1906 20.9857L96.3915 21.7456C96.3915 21.7456 98.5267 27.9217 98.5267 27.9251C99.035 29.3905 98.1306 30.2983 97.0409 31.1296Z",
    fill: "#ED997C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3917 21.7463L98.2328 27.1608L92.6041 29.4269C91.5348 29.8927 90.3346 29.9794 89.2075 29.6768C86.7255 29.007 85.1139 26.6168 85.425 24.0651L85.7888 21.0884L96.3917 21.7463Z",
    fill: "#DB856E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M93.6289 28.9821L98.5079 29.6927L101.18 25.1146C101.702 24.2884 101.456 23.1953 100.628 22.6734C99.8016 22.1515 98.7085 22.3997 98.1883 23.2259L93.6289 28.9821Z",
    fill: "#ED997C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask1",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 13,
    width: 234,
    height: 82
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 13.7H233.929V94.5381H0V13.7Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1396 68.5944L219.064 94.4684C224.145 95.0906 228.767 91.4781 229.39 86.3985L233.859 49.9709C234.483 44.8913 230.87 40.2673 225.789 39.6434L14.8648 13.7694C9.7852 13.1472 5.1629 16.7597 4.539 21.8393L0.0697032 58.2686C-0.552497 63.3482 3.06 67.9705 8.1396 68.5944Z",
    fill: "#93D5F6"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.252 144.624L143.904 137.812L152.783 137.118C154.415 136.941 155.863 137.932 156.015 139.333C156.163 140.731 154.962 142.009 153.329 142.184L141.252 144.624Z",
    fill: "#DB856E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.679 137.846L141.252 144.624L149.963 142.864L140.259 128.341L138.379 129.581C135.627 131.393 134.867 135.094 136.679 137.846Z",
    fill: "#ED997C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M145.248 28.675C136.204 15.4898 113.414 19.0071 114.009 40.133C114.011 40.1942 114.017 40.2605 114.019 40.3234C113.965 43.0026 114.051 45.7294 113.351 48.2505C112.996 49.5238 112.384 50.7087 111.454 51.5638C110.534 52.4291 109.337 52.9374 108.081 53.206C106.809 53.4865 105.439 53.5579 104.025 53.8401C102.604 54.1308 101.218 54.6493 99.9618 55.3973C97.4458 56.8644 95.3888 59.2665 94.447 62.1089C92.645 67.7529 94.0866 74.2792 98.3349 78.5224C99.4025 79.5645 100.643 80.4502 102.003 81.0843C103.358 81.7439 104.902 81.9921 106.151 82.2437C108.783 82.8183 111.44 83.5765 114.157 84.1103L114.233 83.8757C111.733 82.7214 109.266 81.5127 106.616 80.5947C105.235 80.1102 104.049 79.8297 102.983 79.1667C101.91 78.5377 100.922 77.7625 100.093 76.8241C98.4199 74.966 97.2027 72.6744 96.5074 70.2281C95.8138 67.7869 95.6727 65.1434 96.3595 62.7124C97.0361 60.2967 98.6681 58.1904 100.824 56.793C101.895 56.0875 103.091 55.5775 104.343 55.263C105.607 54.9468 106.984 54.8159 108.38 54.447C109.783 54.0866 111.16 53.3777 112.183 52.2914C113.215 51.2102 113.805 49.8162 114.097 48.4375C114.303 47.4515 114.393 46.4706 114.424 45.4914C114.672 49.4286 114.33 53.4287 110.279 54.9417C107.943 55.8138 105.669 55.8155 103.498 57.2622C101.371 58.6817 99.6847 60.7846 98.8602 63.2122C96.3204 70.6854 102.938 80.3516 110.721 81.1778C113.939 81.5195 117.162 82.2981 120.346 82.871C121.237 83.0308 133.761 85.5978 133.863 85.2969L148.352 42.4059L145.248 28.675Z",
    fill: "#1F2041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M144.557 134.775L173.938 114.273L169.838 102.922L140.26 128.34L144.557 134.775Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M166.093 111.466C167.484 114.407 170.998 115.665 173.939 114.273C176.881 112.882 178.138 109.37 176.747 106.427C175.355 103.486 171.843 102.228 168.9 103.621C165.959 105.013 164.703 108.525 166.093 111.466Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M167.561 113.591L175.939 105.302L151.746 78.0968C148.999 74.3908 143.605 73.9777 140.325 77.223C137.046 80.4683 137.403 89.4885 141.078 92.2748L167.561 113.591Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M126.621 75.9887L136.525 76.8268L138.283 56.0749L128.379 55.2368L126.621 75.9887Z",
    fill: "#ED997C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.5401 85.9944C78.2931 86.212 75.8383 89.0204 76.0542 92.2674C76.2718 95.5144 79.0819 97.9692 82.3272 97.7533C85.5742 97.5357 88.0307 94.7273 87.8114 91.4803C87.5955 88.2333 84.7871 85.7768 81.5401 85.9944Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.8291 86.861L83.7978 97.4656L120.276 86.8542C124.747 85.7169 127.172 77.2577 125.41 72.9941C123.651 68.7288 118.522 67.0135 114.549 69.3629L77.8291 86.861Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M133.65 127.776L152.112 82.474C153.044 78.7663 150.545 75.0739 146.757 74.5588L120.254 68.551C116.468 68.0376 113.073 70.931 112.985 74.7543L103.912 124.153L133.65 127.776Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.674 31.0963C127.615 34.9672 122.112 36.5975 120.817 40.1471L120.54 41.7859C120.54 41.8607 120.537 41.9338 120.542 42.012L120.509 41.9593L119.67 46.9301C118.609 53.2201 122.847 59.1803 129.135 60.2411C135.425 61.3036 141.384 57.0655 142.446 50.7772L143.39 45.1825C142.74 39.4875 132.338 39.0489 130.674 31.0963Z",
    fill: "#ED997C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M141.244 48.1236C140.997 49.5839 141.982 50.9677 143.442 51.2142C144.902 51.4607 146.286 50.4764 146.533 49.0161C146.779 47.5575 145.796 46.1737 144.334 45.9272C142.874 45.6807 141.492 46.6633 141.244 48.1236Z",
    fill: "#ED997C"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask2",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 96,
    y: 124,
    width: 35,
    height: 188
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3301 157.583L107.812 311.741H117.56L130.254 158.537L116.97 125.744L103.91 124.154L96.3301 157.583Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.3301 157.583L107.812 311.741H117.56L130.254 158.537L116.97 125.744L103.91 124.154L96.3301 157.583Z",
    fill: "url(#paint0_linear)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M116.971 125.743V158.536L176.758 311.74H184.09L152.101 152.751L133.651 127.775L116.971 125.743Z",
    fill: "#4C3E72"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.874 93.2534C121.874 97.874 118.128 101.619 113.507 101.619C108.886 101.619 105.14 97.874 105.14 93.2534C105.14 88.6328 108.886 84.886 113.507 84.886C118.128 84.886 121.874 88.6328 121.874 93.2534Z",
    fill: "#F6F8F9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.02 68.7735L122.077 86.7408L137.603 70.9206L121.02 68.7735Z",
    fill: "#ED997C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.82 32.485C153.491 30.7935 151.873 29.425 150.074 28.4798C147.155 26.943 143.857 27.1096 141.181 24.8044L143.271 45.8878C147.111 44.7913 146.883 53.0618 142.446 50.777C142.446 50.777 133.65 54.5408 130.311 62.7739C128.022 68.304 127.642 74.7538 128.241 78.4479C129.314 85.0558 134.925 88.4813 141.29 86.5348C145.091 85.3737 148.185 82.5007 150.38 79.1857C158.076 67.5543 163.205 48.4531 156.621 35.3274C156.107 34.304 155.502 33.352 154.82 32.485Z",
    fill: "#1F2041"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M131.026 47.9768C130.342 47.545 125.791 46.6984 125.242 47.0027C124.651 47.3325 124.408 48.1094 124.566 48.7673C124.724 49.4252 125.208 49.9624 125.768 50.3449C127.036 51.2102 128.768 51.3496 130.159 50.7002C130.687 50.452 131.187 50.0746 131.415 49.5374C131.643 49.0019 131.519 48.2896 131.026 47.9768Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.0796 19.7649L84.0116 20.1848C83.4795 23.4879 85.7269 26.5972 89.03 27.1293L89.3785 27.1854C92.6833 27.7175 95.7926 25.4701 96.3247 22.167L96.391 21.7471L84.0796 19.7649Z",
    fill: "#ED997C"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.874 76.3217C75.9553 76.9439 80.5776 73.3314 81.1998 68.2518L85.6691 31.8242C86.293 26.7446 82.6805 22.1206 77.5992 21.4967L14.8648 13.7694C9.7852 13.1472 5.1629 16.7597 4.539 21.8393L0.0697032 58.2686C-0.552497 63.3482 3.06 67.9705 8.1396 68.5944L70.874 76.3217Z",
    fill: "#93D5F6"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 96.329,
    y1: 311.742,
    x2: 130.253,
    y2: 311.742,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B3D72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1F1F41"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardPersonIcon);
export default __webpack_public_path__ + "static/media/dashboard-person-icon.a049d39673197e971a1b97851a002cb3.svg";
export { ForwardRef as ReactComponent };